module.exports = __webpack_public_path__ + "img/samuel-pro.ca63d46f.jpg";